import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class CustomerMissionService {

  constructor(private apiService: ApiService) {}

  /**
   * Save mission
   */
  save(object: any, procedureCode: string): Observable<any> {
    return this.apiService.post('customer/mission/' + procedureCode, object);
  }

  /**
   * Update mission
   */
  update(object: any, procedureCode: string): Observable<any> {
    return this.apiService.put('customer/mission/' + procedureCode, object);
  }
}
